// extracted by mini-css-extract-plugin
export var acitonButtons = "_z-0";
export var additionalIcon = "_z-f";
export var block = "_z-1";
export var blockContent = "_z-7";
export var blockDescription = "_z-8";
export var blockIcon = "_z-9";
export var blockTitle = "_z-6";
export var border = "_z-a";
export var center = "_z-l";
export var edge = "_z-b";
export var edgeLabel = "_z-c";
export var edgePath = "_z-d";
export var error = "_z-e";
export var flowchart = "_z-g";
export var flowchartContent = "_z-h";
export var highlighted = "_z-3";
export var hover = "_z-4";
export var icon = "_z-i";
export var left = "_z-m";
export var navButton = "_z-j";
export var navButtons = "_z-k";
export var right = "_z-n";
export var selected = "_z-2";
export var small = "_z-5";